import React from "react";
import { Link } from 'react-router-dom';


const UserCompanyField = ({
    company,
    subcontractor,
    linked = true,
    className = "",
    emptyValue = "",
}) => {
    const label = subcontractor?.title || company;

    if (!linked)
    {
        return (
            <span className={ className } title={ label || undefined }>
                { label || emptyValue }
            </span>
        );
    }

    return subcontractor?.id ?
        <Link to={ `/subcontractors/${ subcontractor?.id }` }> { subcontractor?.title }</Link> :
        company ?? <strong>&mdash;</strong>;
};

export default UserCompanyField;
